import React from 'react';
import { Link } from 'react-router-dom';
import TeamRequestList from './TeamRequestList';

export default function TeamNotificationsPanel({ orgId, notifications, onUpdated }) {
  const pending = notifications?.pendingCount ?? 0;
  const items = notifications?.items || [];

  return (
    <div className="teams-card teams-notifications">
      <div className="teams-notifications-head">
        <h2>Notifications</h2>
        {pending > 0 && <span className="teams-nav-badge">{pending}</span>}
      </div>
      <p className="teams-sub">
        {pending > 0
          ? `${pending} item${pending === 1 ? '' : 's'} need your response.`
          : 'No pending team invites.'}
      </p>
      {items.length > 0 ? (
        <TeamRequestList orgId={orgId} status="PENDING" compact prefetched={items} onUpdated={onUpdated} />
      ) : null}
      <Link to={`/teams/${orgId}/requests`} className="teams-btn teams-btn--secondary teams-notifications-all">
        Open requests tab
      </Link>
    </div>
  );
}
